import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { formatAmount } from '../../utils/orderFoodUtils';

function TsrOrderSuccessPage() {
  const location = useLocation();
  const state = location.state || {};
  const {
    orderReference,
    tsrFoodOrderId,
    packageName,
    totalAmount,
    paymentStatus,
    couponCode,
    couponDiscountAmount,
    emailSent
  } = state;

  return (
    <div className="container py-5 tsr-order-success">
      <div className="card border-0 shadow-sm rounded-4 mx-auto" style={{ maxWidth: 560 }}>
        <div className="card-body p-4 text-center">
          <h4 className="mb-2">Order placed successfully</h4>
          {orderReference ? (
            <p className="mb-2">
              Reference: <strong>{orderReference}</strong>
            </p>
          ) : (
            <p className="mb-2 text-muted">Thank you for your order.</p>
          )}
          {packageName ? (
            <p className="mb-1">{packageName}</p>
          ) : null}
          {totalAmount ? (
            <p className="text-primary fw-semibold mb-2">{formatAmount(totalAmount)}</p>
          ) : null}
          {paymentStatus ? (
            <p className="small text-muted mb-2">
              Payment status: <strong>{paymentStatus}</strong>
            </p>
          ) : null}
          {couponCode ? (
            <p className="small mb-2">
              Coupon: <span className="badge bg-secondary">{couponCode}</span>
              {couponDiscountAmount > 0 ? (
                <span className="ms-2 text-success">Saved {formatAmount(couponDiscountAmount)}</span>
              ) : null}
            </p>
          ) : null}
          {tsrFoodOrderId ? (
            <p className="small text-muted mb-3">Order ID: {tsrFoodOrderId}</p>
          ) : null}
          {emailSent === false ? (
            <p className="small text-warning mb-3">We could not send a confirmation email. Our team will still follow up.</p>
          ) : (
            <p className="small text-muted mb-3">A confirmation email has been sent to your inbox.</p>
          )}
          <p className="small text-muted mb-4">Payment will be collected separately. Online payment coming soon.</p>
          <Link to="/tsr-order" className="btn btn-primary">Back to packages</Link>
        </div>
      </div>
    </div>
  );
}

export default TsrOrderSuccessPage;
